import { useEffect, useState } from 'react';
import { Spinner } from './ui';

/** Interactive 3D (GLB) viewer. The <model-viewer> web component loads only when a model is shown. */
export function ModelViewer({ src, alt }: { src: string; alt: string }) {
  const [ready, setReady] = useState(!!customElements.get('model-viewer'));
  useEffect(() => { if (!ready) void import('@google/model-viewer').then(() => setReady(true)); }, [ready]);
  if (!ready) return <div className="media__pending"><Spinner /> Loading 3D viewer…</div>;
  return <model-viewer className="model-viewer" src={src} alt={alt} camera-controls auto-rotate autoplay shadow-intensity="1" exposure="1" />;
}
